<template>
  <div class="login-container">
    <h2>🔐 登录账号</h2>
    <form @submit.prevent="handleLogin">
      <div class="form-group">
        <label>用户名：</label>
        <input v-model="username" type="text" placeholder="请输入用户名" />
      </div>

      <div class="form-group">
        <label>密码：</label>
        <input v-model="password" type="password" placeholder="请输入密码" />
      </div>

      <div class="form-group">
        <button type="submit">登录</button>
      </div>

      <p v-if="errorMsg" class="error">{{ errorMsg }}</p>
    </form>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      errorMsg: ''
    }
  },
  methods: {
    handleLogin() {
      if (!this.username || !this.password) {
        this.errorMsg = '❗用户名和密码不能为空'
        return
      }

      if (this.username === 'admin' && this.password === '123456') {
        this.errorMsg = ''
        localStorage.setItem('role', 'admin')
        this.$router.push('/Index') // 登录成功跳转首页
      } else {
        this.errorMsg = '❌ 用户名或密码错误'
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  max-width: 360px;
  margin: 80px auto;
  padding: 30px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
}
h2 {
  text-align: center;
}
.form-group {
  margin-bottom: 16px;
}
input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
button {
  width: 100%;
  padding: 10px;
  background-color: #409eff;
  border: none;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background-color: #66b1ff;
}
.error {
  color: red;
  text-align: center;
}
</style>
